/**
 * Auth0 Provider wrapper component
 */

import { Auth0Provider } from '@auth0/auth0-react'
import { ReactNode } from 'react'
import env from '@/config/env'

interface AuthProviderProps {
  children: ReactNode
}

export function AppAuthProvider({ children }: AuthProviderProps) {
  return (
    <Auth0Provider
      domain={env.VITE_AUTH0_DOMAIN}
      clientId={env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: env.VITE_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  )
}

